import { useTabStore } from "../store/tab-store";
import styled from "styled-components";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { CouponRulesList } from "../constant/coupon-list";
import { useGlobalStore } from "@/store/GlobalStore";
import { CouponType } from "../constant";

export function CouponRules() {
  const { showRules, setShowRules } = useTabStore();
  const { isDomestic } = useGlobalStore();
  const t = getTranslateNsT("coupon");

  if (!showRules) return null;
  return (
    <CouponRulesWrapper>
      <CouponRulesHeader>
        <span>{t("coupon_pages_rules_drawer_title_new")}</span>
        <CloseIcon onClick={() => setShowRules(false)} />
      </CouponRulesHeader>
      <CouponRulesContent>
        {CouponRulesList.filter((i) => {
          if (
            !isDomestic &&
            [CouponType.Qing, CouponType.RenderingMember].includes(i.key)
          ) {
            return false;
          }
          return true;
        }).map((item: { rules: string[]; title: string; key: number }) => {
          const sliceIndex = isDomestic ? item.rules.length : 3;
          return (
            <CouponRulesSection key={item.title}>
              <CouponRulesTitle>{`${t(item.title)}`}</CouponRulesTitle>
              {item.rules.slice(0, sliceIndex).map((p, index) => {
                return <CouponRulesItem key={p}>{t(p)}</CouponRulesItem>;
              })}
            </CouponRulesSection>
          );
        })}
      </CouponRulesContent>
    </CouponRulesWrapper>
  );
}

const CouponRulesWrapper = styled.div`
  border-radius: 4px;
  border: 1px solid #343538;
  background: #292b2f;
  min-width: 386px;
  width: 386px;
`;

const CouponRulesHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 46px;
  padding-left: 12px;
  border-bottom: 1px solid #404246;
`;

const CloseIcon = styled.span`
  position: relative;
  width: 16px;
  height: 16px;
  right: 14px;
  transform: rotate(45deg);
  cursor: pointer;
  &::before {
    height: 100%;
    content: "";
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    border-left: 1px solid #778086;
  }
  &::after {
    width: 100%;
    content: "";
    position: absolute;
    bottom: 50%;
    transform: translate(0, 50%);
    border-bottom: 1px solid #778086;
  }
`;

const CouponRulesContent = styled.div`
  padding: 16px 12px;
`;

const CouponRulesSection = styled.div`
  margin-bottom: 24px;
`;

const CouponRulesTitle = styled.div`
  margin-bottom: 6px;
  font-weight: 600;
`;

const CouponRulesItem = styled.div`
  color: #b3bac0;
  line-height: 20px;
`;
